<style lang="less">
.addBook {
  background: rgb(255, 0, 84) !important;
}
.soldOver {
  background: #999 !important;
}

.write_nav {
  height: 50px;
  position: absolute;
  z-index: 1000;
  top: 100px;
  button {
    font-size: 16px;
  }
}
.goods {
  padding-bottom: 50px;
  &-swipe {
    img {
      width: 7.5rem;
      height: 5.5rem;
      display: block;
    }
  }
  &-title {
    font-size: 16px;
  }
  &-price {
    color: #f44;
  }
  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }
  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }
  .van-search {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
    padding: 0.12rem 0.2rem;

    .nav-back {
      width: 0.44rem;
      height: 0.44rem;
      margin-right: 0.2rem;
      box-sizing: border-box;

      &:nth-child(1) {
        float: left;
      }
      &:nth-child(2) {
        position: absolute;
        float: right;
        right: 0;
      }

      .nav-back-icon {
        display: block;
        width: 100%;
        height: 100%;
        background: url("../../../static/image/icon/ios/back.png") no-repeat
          center center;
      }
    }
    .nav-title-right {
      position: absolute;
      right: 0.34rem;

      div {
        float: left;
        width: 0.34rem;
        height: 0.34rem;

        i {
          display: block;
          width: 100%;
          height: 100%;
          background: url("../../../static/image/icon/ios/back.png") no-repeat
            center center;
        }

        &:nth-child(1) {
          margin-right: 0.26rem;
          & > i {
            background: url("../../../static/image/icon/ios/back.png") no-repeat
              center center;
          }
        }
        &:nth-child(2) {
          margin-right: 0.26rem;
          & > i {
            background: url("../../../static/image/icon/ios/back.png") no-repeat
              center center;
          }
        }
      }
    }
  }
  .skuBox {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    font-size: 0.28rem;
    .skuBox-cont {
      padding: 0 5%;
      .skuBox-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-bottom: 1px solid #e5e5e5;
        padding: 0.2rem 0;
        i {
          font-size: 0.4rem;
        }
        .infor {
          display: flex;
          img {
            width: 1.5rem;
            height: 1.5rem;
          }
          p {
            margin-left: 0.3rem;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            align-items: flex-start;
          }
        }
      }
      .skuBox-wrap {
        border-bottom: 1px solid #e5e5e5;
        padding: 0.2rem 0;
        .title {
          color: #999;
          margin-bottom: 0.2rem;
        }
        ul {
          li {
            height: 0.56rem;
            line-height: 0.56rem;
            border: 1px solid #ccc;
            border-radius: 0.05rem;
            padding: 0 0.2rem;
            display: inline-block;
            margin: 0 0.1rem 0.15rem 0;
            &.active {
              border: 1px solid rgb(255, 144, 0);
              background: rgb(255, 144, 0);
              color: #fff;
            }
          }
        }
      }
    }
    .btn_cart {
      width: 50%;
      height: 0.9rem;
      line-height: 0.9rem;
      border-radius: 0;
      padding: 0;
      border: none;
      background: #ffcc00;
      color: #fff;
      font-size: 0.3rem;
      box-sizing: border-box;
    }
    .btn_buy {
      width: 50%;
      height: 0.9rem;
      line-height: 0.9rem;
      border-radius: 0;
      padding: 0;
      border: none;
      background: rgb(255, 144, 0);
      color: #fff;
      font-size: 0.3rem;
      box-sizing: border-box;
    }
  }

  .van-cell {
    height: 0.88rem;
    padding: 0 0.24rem;

    &:nth-child(1) {
      padding: 0.28rem 0.24rem;
      box-sizing: border-box;

      .goods-price {
        margin-bottom: 0.3rem;
        span {
          display: inline-block;
          &:nth-child(1) {
            font-size: 0.36rem;
            font-weight: bold;
            color: rgb(255, 144, 0);
            margin-right: 0.12rem;
          }
          &:nth-child(2) {
            &::before {
              content: "";
              width: 100%;
              border-top: 1px solid rgb(174, 174, 174);
              height: 1px;
            }
            font-size: 0.24rem;
            color: rgb(174, 174, 174);
          }
        }
      }
      .goods-title {
        span {
          color: #000;
          font-size: 0.28rem;
        }
      }
    }
    &:nth-child(2) {
      .van-cell__value {
        position: relative;
        ul {
          li {
            float: left;
            font-size: 0.1rem;
            color: rgb(94, 94, 94);
            list-style: disc;
            list-style-position: inside;
            margin-right: 0.24rem;

            span {
              font-size: 0.24rem;
              color: rgb(94, 94, 94);
            }
            &:nth-child(1) {
              list-style: none;
            }
          }
        }
        .goods-benfit-all {
          position: absolute;
          right: 0;
          top: 10px;

          i {
            display: block;
            width: 0.44rem;
            height: 0.44rem;
            background: url("../../../static/image/goods/splitPic/fixOrder/ios/more.png")
              no-repeat center center;
          }
        }
      }
    }
    &:nth-child(3) {
      .goods-chose {
        line-height: 0.88rem;
        height: 0.88rem;

        div {
          float: left;

          &:nth-child(1) {
            span {
              color: rgb(0, 0, 0);
              font-size: 0.26rem;
            }
          }
          &:nth-child(2) {
            float: right;
            position: relative;
            top: 10px;

            span {
              display: block;
              top: 0;
              left: 0;
              i {
                display: block;
                width: 0.44rem;
                height: 0.44rem;
                background: url("../../../static/image/goods/splitPic/fixOrder/ios/more.png")
                  no-repeat center center;
              }
            }
          }
        }
      }
    }
    &:nth-child(4) {
      font-size: 0.26rem;
      color: rgb(0, 0, 0);
    }

    &:nth-child(5) {
      .to-fix {
        line-height: 0.88rem;
        text-align: center;

        a {
          width: 100%;
          height: 100%;
          display: block;
          color: #000;
          font-size: 0.22rem;

          i {
            display: block;
            width: 0.26rem;
            height: 0.22rem;
            background: url("../../../static/image/goods/splitPic/fixOrder/ios/more.png")
              no-repeat center center;
          }
        }
      }
    }
  }

  //购物车
  .van-goods-action {
    a {
      width: 33% !important;
      height: 0.88rem !important;
      font-size: 0.28rem;

      &:nth-child(1) {
      }
      &:nth-child(2) {
        background: rgb(255, 204, 0);
        line-height: 0.88rem;
      }
      &:nth-child(3) {
        background: rgb(255, 144, 0);
        line-height: 0.88rem;
      }
    }
  }

  .show_service {
    height: 8.36rem;
    width: 100%;

    & > div:nth-child(1) {
      padding: 0.48rem 0.22rem;

      div {
        font-weight: bold;
        text-align: center;
        font-size: 0.3rem;
        color: rgb(51, 51, 51);
        margin-bottom: 0.52rem;
      }
      div {
        ul {
          li {
            margin-bottom: 0.6rem;
            div {
              padding-left: 0.68rem;

              p {
                text-align: left;
                &:nth-child(1) {
                  font-weight: bold;
                  font-size: 0.26rem;
                  color: rgb(51, 51, 51);
                  margin-bottom: 0.22rem;
                }
                &:nth-child(2) {
                  font-size: 0.22rem;
                  color: rgb(102, 102, 102);
                  word-wrap: break-word;
                }
              }
            }
          }
        }
      }
    }
    .service-btn {
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #ff9000;
      text-align: center;
      font-size: 0.28rem;
      color: #fff;
      height: 1rem;
      line-height: 1rem;
    }
  }

  .skuBox .cart_buy > button {
    float: left;
  }
  .detali_con {
    padding: 0 0.4rem;

    .after_sell {
      margin-top: 0.36rem;

      p {
        text-align: left;
        word-break: break-all;
        font-size: 0.24rem;
        line-height: 0.35rem;
        margin-bottom: 0.1rem;

        &:nth-child(1) {
          text-align: center;
          color: rgb(255, 144, 0);
        }
        &:nth-child(2) {
          color: rgb(102, 102, 102);
        }
      }
    }
    .van-tab {
      font-size: 0.33rem;
    }
    .van-tab--active {
      color: rgb(255, 144, 0);
    }
    .van-tabs__nav-bar {
      background-color: rgb(255, 144, 0);
    }
    .pro_param {
      line-height: 0.98rem;
      border-bottom: 1px solid #e5e5e5;
      margin: 0 -0.4rem;
      padding: 0 0.4rem;
      span {
        vertical-align: top;
        color: rgb(153, 153, 153);
        font-size: 0.28rem;
        display: inline-block;
        width: 1.2rem;
        margin-right: 0.24rem;
      }
      p {
        vertical-align: top;
        color: rgb(51, 51, 51);
        font-size: 0.32rem;
        display: inline-block;
      }
    }
    .show_pro_img {
      margin: 0 -0.4rem;
    }
  }
}
.img-responsive {
  display: block;
  max-width: 100%;
  height: auto;
}
.markNav {
  position: absolute;
  z-index: 9999;
  right: 10px;
  top: 10px;

  & > div {
    width: 100%;
    height: 100%;
  }
  .mark1 {
    width: 100%;
    height: 100%;
    .van-icon {
      width: 100%;
      height: 100%;
      display: block;
      font-size: 16px;

      &::before {
      }
    }
  }
  .mark2 {
    width: 100%;
    height: 100%;
    .van-icon {
      width: 100%;
      height: 100%;
      display: block;
      font-size: 16px;

      &::before {
        color: #ff9000;
      }
    }
  }
}
</style>

<template>
  <div class="goods">
    <!-- <van-nav-bar left-arrow
                 @click-left="onClickLeft" /> -->
    <div v-if='isshow_detail'>
      <div class='nav-back markNav'>
        <div @click="onMark"
             class='mark1'
             v-if='isMark == 0'>
          <van-icon name="like-o" />
        </div>
        <div @click='delMark'
             class='mark2'
             v-else>
          <van-icon name="like" />
        </div>
      </div>
      <van-swipe class="goods-swipe"
                 :autoplay="3000">
        <van-swipe-item v-for="thumb in goods.thumb"
                        :key="thumb">
          <!-- 图片懒加载 -->
          <!-- <img v-lazy="goods.thumb" /> -->
          <img :src="thumb"
               alt="">
        </van-swipe-item>
      </van-swipe>

      <van-cell-group>
        <!-- <van-cell>
        <div class="goods-title">{{ goods.name }}</div>
        <div class="goods-price">￥{{goods.currentPrice}}</div>
      </van-cell>
      <van-cell class="goods-express">
        <van-col span="10">运费：{{ goods.express }}</van-col>
        <van-col span="14">剩余：{{ goods.re
          main }}</van-col>
      </van-cell> -->
        <van-cell>
          <div class="goods-price">
            <span>￥{{goods.currentPrice}}</span>
            <span><del>￥{{goods.oldPrice}}</del></span>
          </div>
          <div class="goods-title">
            <span>{{goods.name}}</span>
          </div>
        </van-cell>
        <van-cell>
          <div class='goods-benfit'
               @click='show_service'>
            <ul class='clearfix'>
              <li><span>无忧退货</span></li>
              <li><span>快速退货</span></li>
              <li><span>免费保修</span></li>
              <li><span>一年保修</span></li>
            </ul>
          </div>
          <div class='goods-benfit-all'>
            <a>
              <i></i>
            </a>
          </div>
        </van-cell>
        <van-cell>
          <div class='goods-chose'
               @click='onAddcart'>
            <div>
              <span>选中&nbsp;&nbsp;颜色分类&nbsp;&nbsp;尺码</span>
            </div>
            <div>
              <span class='goods-chose-enter'>
                <a>
                  <i></i>
                </a>
              </span>
            </div>
          </div>
        </van-cell>
        <van-cell>
          <div>
            <span>同类推荐</span>
          </div>
          <div class='banner'>
          </div>
        </van-cell>
        <van-cell>
          <div class='to-fix'>
            <a @click='showDetail'>
              <!-- <i></i> -->
              <span>点击查看图文详情</span>
            </a>
          </div>
        </van-cell>
        <!-- <van-cell class="goods-express">
        <van-col span="10">运费：{{ goods.express }}</van-col>
        <van-col span="14">剩余：{{ goods.remain }}</van-col>
      </van-cell> -->
      </van-cell-group>
    </div>
    <div v-else
         class='show_detail'>
      <!-- 隐藏图文详情 -->
      <!-- <van-nav-bar title="图文详情"
                   left-arrow
                   @click-left="close_detail" /> -->
      <div class='detali_con'>
        <van-tabs v-model="tabactive">
          <van-tab title="商品介绍">
            <ul class='show_pro_img'>
              <li>
                <img class='img-responsive'
                     :src="goods.pictureDetail[1]"
                     alt="">
              </li>
              <li>
                <img class='img-responsive'
                     :src="goods.pictureDetail[2]"
                     alt="">
              </li>
              <li>
                <img class='img-responsive'
                     :src="goods.pictureDetail[3]"
                     alt="">
              </li>
              <li>
                <img class='img-responsive'
                     :src="goods.pictureDetail[4]"
                     alt="">
              </li>
              <li>
                <img class='img-responsive'
                     :src="goods.pictureDetail[5]"
                     alt="">
              </li>
              <li>
                <img class='img-responsive'
                     :src="goods.pictureDetail[6]"
                     alt="">
              </li>
            </ul>
          </van-tab>
          <van-tab title="规格参数">
            <div class='pro_param'>
              <span>商品编号</span>
              <p>{{goods.detail.goodsNo}}</p>
            </div>
            <div class='pro_param'>
              <span>型号</span>
              <p>{{goods.detail.goodKind}}</p>
            </div>
            <div class='pro_param'>
              <span>类型</span>
              <p>{{goods.detail.goodFun}}</p>
            </div>
            <div class='pro_param'>
              <span>操作方式</span>
              <p>{{goods.detail.goodExt}}</p>
            </div>
            <div class='pro_param'>
              <span>颜色</span>
              <p>{{goods.detail.goodsColorCover}}</p>
            </div>
            <div class='pro_param'>
              <span>机身尺寸</span>
              <p>{{goods.detail.goodsUseCover}}</p>
            </div>
            <div class='pro_param'>
              <span>生产商</span>
              <p>{{goods.detail.goodsProduct}}</p>
            </div>
          </van-tab>
          <van-tab title="包装售后">
            <div class='after_sell'>
              <p>包装清单</p>
              <p>{{goods.detail.goodpackaging}}</p>
            </div>
            <div class='after_sell'>
              <p>售后服务</p>
              <p>{{goods.detail.goodAfterSale}}</p>
            </div>
            <div class='after_sell'>
              <p>价格说明</p>
              <p>{{goods.detail.priceIntroduce}}</p>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- v-if='sku_num>0' -->
    <van-goods-action v-if='sku_num>0'>
      <van-goods-action-mini-btn icon="cart"
                                 :info="cartCount>0?cartCount:''"
                                 @click="goCart">
        购物车
      </van-goods-action-mini-btn>
      <van-goods-action-big-btn @click="onAddcart">
        加入购物车
      </van-goods-action-big-btn>
      <van-goods-action-big-btn primary
                                @click="onAddBuy">
        立即购买
      </van-goods-action-big-btn>
    </van-goods-action>
    <van-goods-action v-else>
      <van-goods-action-mini-btn icon="cart"
                                 :info="cartCount>0?cartCount:''"
                                 @click="goCart">
        购物车
      </van-goods-action-mini-btn>
      <van-goods-action-big-btn @click="onMark"
                                class='addBook'>
        加入收藏夹
      </van-goods-action-big-btn>
      <van-goods-action-big-btn class='soldOver'>
        已售罄
      </van-goods-action-big-btn>
    </van-goods-action>

    <!--购物弹窗-->
    <van-popup v-model="isShow"
               position="bottom"
               transition="popup-slide">
      <div class="skuBox">
        <div class="skuBox-cont">
          <div class="skuBox-top">
            <div class="infor">
              <img :src="sku_pic">
              <p>
                <span class="price">{{goods.currentPrice}}</span>
                <span class="selected">已选：{{'"'+this.color+'","'+this.size+'"'}}</span>
                <span class="count">库存：{{sku.sku_num}}</span>
              </p>
            </div>
            <i class="van-icon van-icon-close"
               @click="closeBtn"></i>
          </div>
          <div class="skuBox-wrap">
            <!-- <div class="title">颜色</div>
            <ul>
              <li v-for="(item,index) in sku.color"
                  :key="index"
                  :class="{active: index === nowIndex}"
                  @click="chooseType(index)">{{kinds[index].kindName}}</li>
            </ul> -->
            <div class="title">颜色分类</div>
            <ul>
              <li v-for="(color,index) in sku.sku_color"
                  :key="index"
                  :class="{active: index === nowIndex_color}"
                  @click="chooseColor(index)">{{color}}</li>
            </ul>
            <div class="title">尺寸</div>
            <ul>
              <li v-for="(size,index) in sku.sku_size"
                  :key="index"
                  :class="{active: index === nowIndex_size}"
                  @click="chooseSize(index)">{{size}}</li>
            </ul>
          </div>
          <div class="skuBox-wrap">
            <div class="title">购买数量</div>
            <van-stepper v-model="count"
                         :max="sku.sku_num"
                         @plus="onPlusStep"
                         @minus='onMinusStep' />
          </div>
        </div>
        <div class='cart_buy'>
          <button class='btn_cart'
                  @click="addToCart">加入购物车</button>
          <button class='btn_buy'
                  @click="addToBuy">立即购买</button>
        </div>
      </div>
    </van-popup>

    <!-- 服务弹出框 -->
    <van-popup v-model="isShow_service"
               position="bottom"
               transition="popup-slide">
      <div class='show_service'>
        <div>
          <div>服务说明</div>
          <div>
            <ul>
              <li>
                <div>
                  <p> 七天无忧退货说明</p>
                  <p>自收到商品之日起7天内，可在线申请无忧退货服务</p>
                </div>
              </li>
              <li>
                <div>
                  <p> 48小时快速退款</p>
                  <p>收到退货包裹并确认无误后，将在48小时内办理退款，退款将原路返回，不同银行处理时间不同，预计1-5个工作日到账</p>
                </div>
              </li>
              <li>
                <div>
                  <p> 满88元免费邮费</p>
                  <p>单笔订单金额（不含运费）满88元可免邮费，不满88元，单笔订单收取10元邮费</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class='service-btn'
             @click="close_service">
          确定
        </div>
      </div>
    </van-popup>
    <!-- <van-popup v-if="isMark==1">收藏成功</van-popup>
    <van-popup v-else>取消收藏</van-popup> -->
  </div>
</template>

<script>
import axios from 'axios';
import url from '../../assets/js/api.js'
import store from '@/vuex/store'
import { mapState } from 'vuex'
import { Dialog } from 'vant'
import { constants, stat } from 'fs';
import { debug, debuglog } from 'util';
import { Toast } from 'vant';
import { Icon } from 'vant';
const newLocal = false;
export default {
  store,
  data () {
    return {
      isMark: 0,//是否收藏,0点击收藏、1取消收藏
      nowIndex_color: 0,
      nowIndex_size: 0,
      goods: {},//加入isMark标志
      id: this.$route.params.id,
      isShow: newLocal,
      kinds: [],
      kindName: '',//已选
      total: '',//库存：
      kid: '',//类型id
      smpic: '',//图片,sku弹窗的照片
      count: 1,//订购
      color: '白色',
      size: '标准版',
      color_size: '',
      cartCount: '',
      isBuy: false,
      isCart: false,
      isShow_service: false,
      isShow_nav: true,
      sku: {},
      isshow_detail: this.$store.state.isshow_detail,
      tabactive: 1,
      desc: '',
      sku_num: '',
      sku_pic: "", //图片sku的展示图片
      isCloseDone: false,
    }
  },
  watch: {
    //监听数值 isshow_detail
    showStoreDetail (newVal, oldVal) {
      debugger
      console.log(newVal);
      if (newVal == true && this.$store.state.closeDetailP == true) {

        this.close_detail();
      }
    }
  },
  mounted () {
    //全局变量
    //  window['isshow_detail'] = this.$store.state.isshow_detail;
    // //////debugger
    if (this.$route.params.id == 'catCamera') {
      this.color = '黑色';
    }
    console.log('45rwerw54erwefdscsyrewdsa');


    this.getDetails();
    console.log(this.goods);

    this.upDateCount();
    this.sku_num = this.sku.sku_num;

    //console.log(this.goods);
    this.isMark = this.goods.isMark;

    this.chooseColor(0);//默认显示第一张
    // ////////debugger
    //返回调用
    window['backToHome'] = () => {
      //////debugger
      this.$router.push('/home');
    }
    ////////debugger
  },
  computed: {
    ...mapState({
      selectGoods: state => state.selectGoods,//绑定store.selectGoods到组件，之后可用this.selectGoods获取
      toBuy: state => state.toBuy,
      isRightToBuy: state => state.isRightToBuy,
      //show_nav: state => state.isShow_nav
    }),
    showStoreDetail () {
      return this.$store.state.isshow_detail;
    }
  },
  methods: {
    //计步数的改变
    //增加的按钮改变的事件
    // getAndroid (a) {
    //   window.Android.showToast();
    // },
    showToast (a) {
      window.android.showToastTest(a);
    },
    onPlusStep () {
      this.sku.sku_num--;
      this.sku_num = this.sku.sku_num;
    },
    onMinusStep () {
      this.sku.sku_num++;
      this.sku_num = this.sku.sku_num;
    },
    //展示图文详情
    showDetail () {
      //  debugger

      this.$store.commit('isshow_detail', false);
      this.isshow_detail = this.$store.state.isshow_detail;
    },
    //图文详情返回商品页
    close_detail () {
      this.$store.commit('isshow_detail', true);
      this.isshow_detail = this.$store.state.isshow_detail
    },
    //返回
    onClickLeft () {
      this.$router.go(-1);
    },
    //详情页商品重新赋值
    getDetails () {
      // //////debugger;
      var target_pro_id = this.$route.params.id;
      this.goods = this.$store.getters.getTarget_pro_id(target_pro_id);

      console.log(this.goods);
      this.sku = this.goods.sku;
    },

    //选择颜色
    chooseColor (index) {
      this.nowIndex_color = index;
      this.color = this.sku.sku_color[index];
      this.sku_pic = this.goods.sku.sku_pic[index];
    },
    chooseSize (index) {
      this.nowIndex_size = index;
      this.size = this.sku.sku_size[index];
    },

    //客服
    toPhone () {
      alert("请联系客服--239983");
    },
    onAddcart () {
      this.isShow = true;
      this.isBuy = false;
      this.isCart = true;
      console.log('1111111');
      this.count = 1
    },
    //显示购买模块
    onAddBuy () {
      this.isShow = true;
      this.isBuy = true;
      this.isCart = false;
      console.log('1111111')
      this.count = 1
    },
    //显示服务模块
    show_service () {
      this.isShow_service = true;
    },
    close_service () {
      this.isShow_service = false;
    },
    closeBtn () {
      this.isShow = !this.isShow
    },
    stop (event) {
      event.cancelBubble = true
    },
    sendGift () {

    },
    //选择类型
    chooseType (index) {
      this.nowIndex = index
      this.kindName = this.kinds[index].kindName
      this.total = this.kinds[index].total
      this.kid = this.kinds[index].kid
    },
    //加入购物车
    addToCart () {
      // debugger
      console.log('111111132432')
      console.log(this.selectGoods)
      let flag = true;
      let num = 0;
      this.kid = this.id + '-' + this.color + '-' + this.size;

      this.selectGoods.forEach((item, index) => {
        // 通过kid值判断购物车是否已经存在商品,如果存在就不添加
        if (this.kid == item.kid) {
          flag = false;
          if (this.count != item.count) {
            item.count += this.count

            this.isShow = !this.isShow
            this.upDateCount()
          }
        }
      });

      if (flag) {
        //提交信息
        this.$store.dispatch('addGoods', {
          name: this.goods.name,
          price: this.goods.currentPrice,
          id: this.goods.id,
          smpic: this.goods.smpic,
          kid: this.kid,
          color: this.color,
          size: this.size,
          count: this.count,
          check: true,
          desc: this.desc,
          goodsDetail: this.goods
        })
        this.upDateCount()
        this.isShow = !this.isShow
      }
    },
    // 立即购买
    addToBuy () {
      this.kid = this.id + '-' + this.color + '-' + this.size;
      store.commit('change_isRightToBuy');
      this.$store.commit('isDetailOrCart', 0);
      this.toBuy.length = 0;
      var obj = {
        name: this.goods.name,
        price: this.goods.currentPrice,
        id: this.goods.id,
        smpic: this.goods.smpic,
        kid: this.kid,
        color: this.color,
        size: this.size,
        count: this.count,
        check: true,
        desc: this.desc,
        goodsDetail: this.goods
      }
      this.toBuy.push(obj);
      this.$store.state.commonGood = [];
      this.$store.state.commonGood.push(obj);

      // //////debugger
      console.log(this.toBuy);
      // this.$store.state.detailChosenList = this.toBuy;
      this.$store.commit('getDetailSkuList', this.toBuy[0]);

      this.$router.push({ name: '/pay', params: { isDetailOrCart: 0 } })  //要带上参数，否则返回为空
    },

    //更新购物车数量
    upDateCount () {
      let num = 0;
      this.selectGoods.forEach((item, index) => {
        num += item.count;
      });
      this.cartCount = String(num)
    },
    //跳转到购物车
    goCart () {
      this.$router.push({ path: '/cart' });
    },
    //加入收藏夹
    onMark () {
      this.isMark = 1;
      this.goods.isMark = 1;

      //全部的商品信息
      this.goods.goodsDetail = this.goods;
      //this.$store.state.bookMark.push(this.goods);
      this.$store.commit('addBookMark', this.goods)
      console.log(this.goods);
      this.$store.state.bookMark = this.unique(this.$store.state.bookMark);

      Toast({
        message: '收藏成功'
      });
      console.log(this.$store.state.bookMark);
    },
    //取消收藏夹
    delMark () {
      this.isMark = 0;
      this.goods.isMark = 0;
      this.$store.state.bookMark = this.$store.state.bookMark.filter(item => {
        return item.id != this.id;
      })
      console.log(this.$store.state.bookMark);
      Toast({
        message: '取消收藏'
      });
    },
    unique (arr) {
      let hashTable = {};
      let newArr = [];
      for (let i = 0, l = arr.length; i < l; i++) {
        if (!hashTable[arr[i].id]) {
          hashTable[arr[i].id] = true;
          newArr.push(arr[i]);
        }
      }
      return newArr;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/detail/detail.vue